import { useContext, useEffect, useRef, useState } from "react";
import { DataContext } from "../../context/Data";
import { FirebaseContext } from "../../context/Firebase";

export default function LiveData() {
  const { account } = useContext(DataContext);
  const { functions, db } = useContext(FirebaseContext);
  const intervalRef = useRef(null);
  const timeoutRef = useRef(null);

  const [isRunning, setIsRunning] = useState(true);

  const [isEnablePullData, setIsEnablePullData] = useState(true);
  const [intervalToPull, setIntervalToPull] = useState(180000);

  const getLiveData = async () => {
    await functions.liveData({ account_eid: account });
  };

  const startAll = () => {
    if (!isEnablePullData) {
      console.log("⛔ Pull disabled.");
      return;
    }

    console.log("▶️ Starting pull:", intervalToPull);
    getLiveData();

    intervalRef.current = setInterval(getLiveData, intervalToPull);

    timeoutRef.current = setTimeout(() => {
      console.log("⏱️ Timeout (30min). Stopping the process.");
      stopAll();
    }, 30 * 60 * 1000);

    setIsRunning(true);
  };

  const stopAll = () => {
    console.log("🛑 Stopping LiveData");

    if (intervalRef.current) clearInterval(intervalRef.current);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    intervalRef.current = null;
    timeoutRef.current = null;

    setIsRunning(false);
  };

  const handleToggle = () => {
    if (isRunning) {
      stopAll();
    } else {
      startAll();
    }
  };

  useEffect(() => {
    startAll();

    return () => {
      stopAll();
    };
  }, []);

  useEffect(() => {
    const unsub = db
      .collection("portal_config")
      .doc("live_data_config")
      .onSnapshot((doc) => {
        const data = doc.data();
        const enabled = data?.enabled ?? false;
        const interval = data?.interval ?? 180000;

        setIsEnablePullData(enabled);
        setIntervalToPull(interval);
      });

    return () => unsub();
  }, []);

  useEffect(() => {
    if (!isEnablePullData && isRunning) {
      console.log("⚠️ Pull data disabled.");
      stopAll();
    }
  }, [isEnablePullData]);

  useEffect(() => {
    if (isRunning) {
      console.log("🔁 New interval:", intervalToPull);
      stopAll();
      startAll();
    }
  }, [intervalToPull]);

  useEffect(() => {
    return () => stopAll();
  }, []);

  return (
    <div className="flex justify-end items-center">
      <label className="flex items-center gap-2 cursor-pointer">
        <span className="text-sm">Auto-refresh</span>
        <div className="relative">
          <input
            type="checkbox"
            checked={isRunning}
            onChange={handleToggle}
            disabled={!isEnablePullData}
            className="sr-only"
          />
          <div className={`w-11 h-6 rounded-full transition-colors ${isRunning ? "bg-sub" : "bg-grey-selected"}`}></div>
          <div
            className={`absolute top-0.5 left-0.5 w-5 h-5 rounded-full shadow-md transition-transform transform ${
              isRunning ? "translate-x-5 bg-main" : "translate-x-0 bg-grey"
            }`}
          ></div>
        </div>
      </label>
    </div>
  );
}
